// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2-9L6","withIcon":"Button_withIcon__3nGhF","alt":"Button_alt__2GvXQ","label":"Button_label__pPgCe","secondary":"Button_secondary__C0DUl"};